// extracted by mini-css-extract-plugin
export default {"progressContainer":"styles_progressContainer__twz61","progressBar":"styles_progressBar__RYhRe"};